import {
  GENERATE_WIP_REPORT_AI_ORATION,
  GENERATE_WIP_REPORT_SUMMARY,
  GET_WIP_REPORT_AI_SUMMARY,
  LIST_WIP_REPORT_AI_SUMMARIES,
} from './query'

export const generateWipReportSummary = async (
  client,
  projectId,
  month,
  matterContext,
  options = {},
) => {
  const { systemPromptId, conversation, idempotencyKey } = options
  const { data } = await client.mutate({
    mutation: GENERATE_WIP_REPORT_SUMMARY,
    variables: {
      projectId,
      month,
      matterContext: matterContext ?? null,
      systemPromptId: systemPromptId ?? null,
      conversation: conversation ?? null,
      idempotencyKey: idempotencyKey ?? null,
    },
  })
  return data.generateWipReportSummary
}

export const generateWipReportAiOration = async (client, projectId, month, options = {}) => {
  const { idempotencyKey } = options
  const { data } = await client.mutate({
    mutation: GENERATE_WIP_REPORT_AI_ORATION,
    variables: {
      projectId,
      month,
      idempotencyKey: idempotencyKey ?? null,
    },
  })
  return data.generateWipReportAiOration
}

export const listWipReportAiSummaries = async (client, projectId, month) => {
  const { data } = await client.query({
    query: LIST_WIP_REPORT_AI_SUMMARIES,
    variables: { projectId, month },
    fetchPolicy: 'network-only',
  })
  return data.listWipReportAiSummaries
}

export const getWipReportAiSummary = async (client, id) => {
  const { data } = await client.query({
    query: GET_WIP_REPORT_AI_SUMMARY,
    variables: { id },
    fetchPolicy: 'network-only',
  })
  return data.getWipReportAiSummary
}
